import { createContext, PropsWithChildren, useContext } from 'react';

const IdentityContext = createContext('');

export const IdentityProvider = (
  props: PropsWithChildren<{ value: string }>,
) => {
  return (
    <IdentityContext.Provider value={props.value}>
      {props.children}
    </IdentityContext.Provider>
  );
};

export const useIdentity = () => {
  const context = useContext(IdentityContext);
  if (typeof context !== 'string')
    throw new Error(
      'Error while calling useIdentity! Context has incorrect type (expected string)',
    );
  return context;
};
